import { render, staticRenderFns } from "./UpdateBannerPage.vue?vue&type=template&id=19ad693c&scoped=true"
import script from "./UpdateBannerPage.vue?vue&type=script&lang=js"
export * from "./UpdateBannerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ad693c",
  null
  
)

export default component.exports